import { useState } from "react"
import translate2 from "../translations/translationMain.js"
import { FormGroup, Input, Label } from "reactstrap"
import loyaltyShowPassword from "../assets/loyaltyShowPassword.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import useColors from "../customHooks/useColors.js"
import { Children } from "react"

const BaseInput = (props) => {
  ////////////////////////////////////////////////////////////destructured props
  const {
    onFocus = () => {},
    onBlur = () => {},
    onChange = () => {},
    onKeyUp = () => {},
    onKeyDown = () => {},
    onEnter = () => {},
    onKeyPress = () => {},
    onClick = () => {},
    style = {},
    className = "",
    value,
    placeholder,
    innerRef,
    type = "text",
    maxLength,
    id,
    readOnly = false,
    isVerified = null,
    verifyIconFunction = () => {},
    verificationIconTitle = "",
    children = null,
    hasFormWrapper = true,
    translate = true,
  } = props

  //////////////////////////////////////////current theme
  const [currentColors] = useColors()

  //////////////////////////////////////////current lang

  const vPlaceholder = translate
    ? translate2({ key: placeholder })
    : placeholder

  //////////////////////////////////////////LOCAL STATE
  const [isFocused, setIsFocused] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  //////////////////////////////////////////enhanced functions
  const enhancedFocus = () => {
    if (onFocus instanceof Function) {
      onFocus()
    }
    setIsFocused(true)
  }

  const enhancedBlur = () => {
    if (onBlur instanceof Function) {
      onBlur()
    }
    setIsFocused(false)
  }

  const enhancedChange = (e) => {
    if (onChange instanceof Function && readOnly === false) {
      onChange(e)
    }
  }

  const enhancedKeyUp = (e) => {
    if (onKeyUp instanceof Function && readOnly === false) {
      onKeyUp(e)
    }
    if (e.key === "Enter") {
      onEnter()
    }
  }

  //////////////////////////////////////////STYLES
  const styles = {
    mainInput: {
      flex: 1,
      borderWidth: 0,
      borderBottomWidth: isFocused ? "3px" : "2px",
      borderColor: currentColors.primary,

      borderRadius: "0px",
      paddingLeft: "5px",
      paddingTop: "35px",
      backgroundColor: "transparent",
      fontSize: "19px",
    },
    mainLabel: {
      paddingLeft: "3px",
      paddingBottom: "5px",
      transition: "all 0.2s ease",
      color: currentColors.quaternary,
      fontSize: "18px",
    },
    eye: {
      cursor: "pointer",
      width: "25px",
      height: "25px",
      marginLeft: "5px",
      selfAlign: "center",
      color: currentColors.primary,
    },
  }

  if (hasFormWrapper === false) {
    styles.mainInput.borderBottomWidth = "0px"
  }

  //////////////////////////////////////////RENDER
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <WithWrapper hasFormWrapper={hasFormWrapper}>
        <Input
          disabled={readOnly}
          onFocus={enhancedFocus}
          onBlur={enhancedBlur}
          style={{ ...styles.mainInput, ...style }}
          placeholder={vPlaceholder}
          value={value}
          onChange={enhancedChange}
          onClick={onClick}
          className={`${className} shadow-none`}
          innerRef={innerRef}
          type={
            type === "password" ? (showPassword ? "text" : "password") : type
          }
          maxLength={maxLength}
          onKeyUp={enhancedKeyUp}
          onKeyDown={onKeyDown}
          onKeyPress={onKeyPress}
          id={id}
        >
          {children}
        </Input>

        {placeholder && <Label style={styles.mainLabel}>{vPlaceholder}</Label>}
      </WithWrapper>
      {type === "password" && (
        <span
          style={styles.eye}
          onClick={() => {
            setShowPassword((prevstate) => !prevstate)
          }}
        >
          <img src={loyaltyShowPassword} />
        </span>
      )}
      {isVerified !== null && (
        <span>
          {isVerified === true ? (
            <FontAwesomeIcon icon={faCheck} />
          ) : (
            <FontAwesomeIcon
              title={translate2({ key: verificationIconTitle })}
              style={{ cursor: "pointer" }}
              icon={faCircleXmark}
              onClick={verifyIconFunction}
            />
          )}
        </span>
      )}
    </div>
  )
}

const WithWrapper = ({ children, hasFormWrapper = true }) => {
  if (hasFormWrapper) {
    return (
      <FormGroup style={{ flex: 1 }} floating>
        {children}
      </FormGroup>
    )
  } else {
    return <span>{children}</span>
  }
}

export default BaseInput
